import React from 'react';
import { Alert, AlertTitle, Stack, Typography } from '@mui/material';

const SEVERITIES = [
  { key: 'error', title: 'Errors' },
  { key: 'warning', title: 'Warnings' },
  { key: 'info', title: 'Notes' },
];

const normalizeSeverity = (severity) => {
  const value = String(severity || '').toLowerCase();
  return ['error', 'warning', 'info'].includes(value) ? value : 'warning';
};

export const countAttentionWarnings = (warnings = []) =>
  warnings.filter((w) => normalizeSeverity(w.severity) !== 'info').length;

const ScheduleWarnings = ({ warnings = [], teamNames }) => {
  if (warnings.length === 0) {
    return <Alert severity="success">No warnings — this schedule looks balanced.</Alert>;
  }

  return (
    <Stack spacing={2}>
      {SEVERITIES.map(({ key, title }) => {
        const items = warnings.filter((w) => normalizeSeverity(w.severity) === key);
        if (items.length === 0) return null;
        return (
          <Alert key={key} severity={key} data-testid={`warnings-${key}`}>
            <AlertTitle>{`${title} (${items.length})`}</AlertTitle>
            <Stack component="ul" spacing={0.5} sx={{ m: 0, pl: 2 }}>
              {items.map((w, index) => (
                <Typography component="li" variant="body2" key={`${w.code}-${w.teamId ?? 'all'}-${index}`} sx={{ wordBreak: 'break-word' }}>
                  {w.teamId && teamNames?.get(w.teamId) && !w.message.includes(teamNames.get(w.teamId))
                    ? `${teamNames.get(w.teamId)}: ${w.message}`
                    : w.message}
                </Typography>
              ))}
            </Stack>
          </Alert>
        );
      })}
    </Stack>
  );
};

export default ScheduleWarnings;
